import { DeviceConfig } from "../config/documents/HardwareConfig";

/**
 * Convert up to date config into a legacy format. (Reverse-migrate)
 * Legacy version can be selected by the AutoFilterVersion parameter.
 * @param deviceConfig 
 * @param AutoFilterVersion 
 * @returns 
 */
export function convertConfigHvac(deviceConfig: DeviceConfig, AutoFilterVersion?: number): DeviceConfig {
    if (typeof AutoFilterVersion === "undefined" || AutoFilterVersion >= 27) {
        return deviceConfig;
    } else {
        // Convert config into legacy format. (pre v27)
        const ret = JSON.parse(JSON.stringify(deviceConfig));
        if (!ret.HardwareDevice) ret.HardwareDevice = {};
        if (ret.HardwareDevice.HVACSettings) {
            ret.HardwareDevice.MinAirOperatingTempF = ret.HardwareDevice.HVACSettings.MinAirOperatingTempF;
            ret.HardwareDevice.MaxAirOperatingTempF = ret.HardwareDevice.HVACSettings.MaxAirOperatingTempF;
            ret.HardwareDevice.SupportHeating = ret.HardwareDevice.HVACSettings.SupportHeating;
            ret.HardwareDevice.SupportCooling = ret.HardwareDevice.HVACSettings.SupportCooling;
            ret.HardwareDevice.CooldownSeconds = ret.HardwareDevice.HVACSettings.CooldownSeconds;
            delete ret.HardwareDevice.HVACSettings;
        }
        return ret;
    }
}